import FastOrderModal from 'features/fast-order/FastOrderModal';
import ChatLimitModal from 'features/chat/Modals/ChatLimitModal';
import { GlobalModalType } from './types';

export const modalComponentList = {
  [GlobalModalType.FastOrder]: FastOrderModal,
  [GlobalModalType.ChatLimit]: ChatLimitModal,
} as const;
